/** Compatibility export; the business domain owns this implementation. */
export { AMAZON_MARKETPLACE_LANGUAGES_CODES, AMAZON_NAME_MAPPINGS, EnumAmazonCategory, EnumAmazonColor, EnumAmazonFitType, EnumAmazonFulfillmentType, EnumAmazonMarketplace, EnumAmazonProduct, EnumAmazonSorting } from '@domains/research/shared';
